import { useColorModeValue } from '@chakra-ui/react'

/**
 * Centralized theme-aware colors hook
 * Use this hook to get consistent theme colors across all pages
 */
export function useThemeColors() {
  return {
    // Background colors
    bg: useColorModeValue('gray.50', 'gray.900'),
    cardBg: useColorModeValue('white', 'gray.800'),
    sectionBg: useColorModeValue('gray.50', 'gray.900'),
    
    // Text colors (dark mode: ensure sufficient contrast per UAT)
    heading: useColorModeValue('gray.800', 'gray.100'),
    text: useColorModeValue('gray.700', 'gray.200'),
    textSecondary: useColorModeValue('gray.500', 'gray.400'),
    textMuted: useColorModeValue('gray.400', 'gray.500'),
    
    // Link and interactive colors
    link: useColorModeValue('gray.600', 'gray.300'),
    linkHover: useColorModeValue('blue.600', 'blue.400'),
    primary: useColorModeValue('blue.600', 'blue.400'),
    buttonColor: useColorModeValue('blue.500', 'blue.400'),
    
    // Border colors
    border: useColorModeValue('gray.200', 'gray.700'),
    borderLight: useColorModeValue('gray.100', 'gray.800'),
    
    // Input colors
    inputBg: useColorModeValue('white', 'gray.700'),
    inputBorder: useColorModeValue('gray.300', 'gray.600'),
    
    // Progress and status colors
    progressBg: useColorModeValue('gray.200', 'gray.700'),

    // Modal (dark mode)
    modalBg: useColorModeValue('white', 'gray.800'),
    
    // Email and highlight colors
    email: useColorModeValue('blue.600', 'blue.400'),
    
    // Upload area colors
    uploadHover: useColorModeValue('blue.50', 'blue.900'),
    uploadIcon: useColorModeValue('gray.400', 'gray.500'),
  }
}

